<template>
  <header class="brand-header">
    <div class="brandbar">
      <div class="container-fixed">
        <div v-if="isTelekom">
          <div class="brand-logo">
            <img src="@/assets/telekom-brand-and-design/images/deutsche-telekom-logo.svg" width="153" height="38" :alt="$t('common.logoClaim')" type="svg" />
          </div>
        </div>
        <div v-else-if="isLogoAvailable">
          <div class="brand-logo">
            <img class="wholesalelogo" :src="`delegates/conf/wholesalepartner/logo_${wholesalePartnerId}`" alt="" />
          </div>
        </div>
        <div class="logout-timer">
          <p>{{ $t('common.sessionTimeout.title') }}: {{ formattedCountdown }}</p>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { formatTimeFromSeconds } from '@/utils/date';

export default {
  name: 'CommonguiHeader',

  computed: {
    ...mapState('system', ['wholesalePartnerId']),
    ...mapGetters('system', ['isTelekom', 'isLogoAvailable']),
    ...mapGetters('timer', ['remainingSeconds']),

    formattedCountdown() {
      return formatTimeFromSeconds(this.remainingSeconds);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

.logout-timer {
  font-size: $font-size-regular;
  font-weight: $font-weight-semibold;
  color: $cl-element-font-color-brand;
}
</style>
